/**
 * Medical Equipment Guidance - Simple Direct Pattern
 * Uses requirement ID mapping from medical.simple.js
 */

import { MEDICAL_GUIDANCE } from "./medical.simple";

/**
 * Get Medical Equipment Guidance
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getMedicalGuidance(itemId) {
  // Early return - no debug logging for missing guidance
  return MEDICAL_GUIDANCE[itemId] || null;
}